import { useEffect, useState } from 'react';

/**
 * Holds a transient message that clears itself after a delay.
 *
 * Success notices should confirm and then get out of the way; keeping them on
 * screen until navigation makes the page read as permanently "just saved".
 */
export function useAutoDismiss(durationMs = 4000) {
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    if (message === null) {
      return;
    }
    const timer = window.setTimeout(() => {
      setMessage(null);
    }, durationMs);
    return () => {
      window.clearTimeout(timer);
    };
  }, [message, durationMs]);

  return [message, setMessage] as const;
}
